import React, { FunctionComponent, useMemo } from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

import { TIME_ZONES } from '../../utils/time-zone-utils';
import useTimeZone from '../hooks/useTimeZone';

interface Props {
  selected: string | undefined;
  onSelect: (timezone: string | undefined) => void;
  disabled?: boolean;
  readonly?: boolean;
}

const SelectTimeZoneControl: FunctionComponent<Props> = ({ selected, onSelect, disabled, readonly }: Props) => {
  const { getGmtModifier } = useTimeZone();
  const fieldName = 'Display Time Zone';

  const selectedGmt = useMemo(() => {
    if (selected) {
      return getGmtModifier(selected);
    }
  }, [selected]);

  return (
    <FormControl fullWidth>
      <InputLabel id="timezone-label" size="small">
        {fieldName}
      </InputLabel>
      <Select
        readOnly={readonly}
        name="timezone-label"
        labelId="timezone-label"
        value={selected ?? ''}
        label={fieldName}
        onChange={(e) => onSelect(e.target.value)}
        disabled={disabled}
        size="small"
      >
        <MenuItem key="" value="">
          Velg..
        </MenuItem>
        {TIME_ZONES.map((x) => (
          <MenuItem key={x.value} value={x.value}>
            {x.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{selectedGmt}</FormHelperText>
    </FormControl>
  );
};

export default SelectTimeZoneControl;
